import { authorizedApiClient } from "./config";

export const currentUser = async () => authorizedApiClient.get("/users/me");

export const user = "USER";
